<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          morematization Products
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/p41.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">基于经纬度信息的辅助室外巡检导航系统</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            经纬度信息的辅助室外巡检导航系统。该系统可以使得使用用户通过级联方式查询到
            室外电力设备，提供电力设备的经纬度信息，同时，基于经纬度信息，通过详细的基
            于经纬度的导航服务。通过经纬度辅助巡检导航系统，可以做到快速响应室外电力设
            备的故障响应，简化室外电力设备的巡检流程，提高室外电力设备的巡检工作效率，
            降低巡检工作投入的时间成本和经济成本。
          </div>
          <div class="title">相关案例</div>
          <div class="introimg">
             <img src='../assets/p42.png' alt="">
             <div class="intro" @click="gotoDetail">
              <span class="el-icon-right" ></span>
             </div>
          </div>
          
          <div class="txt last">基于经纬度信息的辅助室外巡检导航系统</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">精确度高</div>
            <div class="en">High accuracy</div>
            <div class="txt"><span class="el-icon-caret-right"></span>此系统是采用微信小程序进行开发，支持远
程访问，并且通知可以随时发放，打破地理
位置的局限性。</div>
          </div>
          <div class="more_list ">
            <div class="title">结构化管理</div>
            <div class="en">Structured Management</div>
            <div class="txt"><span class="el-icon-caret-right"></span>面对大区域内的用户，每一个用户的配电网
线路都不尽相同，在程序逻辑中即对用户进
行分区域通知，不会推送对于用户无用的信
息。</div>
          </div>
          <div class="more_list end">
            <div class="title">跨平台性</div>
            <div class="en">Cross-platform</div>
            <div class="txt"><span class="el-icon-caret-right"></span>本系统使用Java语言进行开发，架设在web
网页上，具有很好的跨平台性和可扩展性。</div>
          </div>
          
        </div>
        <div class="more_bottom">
           
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code3.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail4')
    }
  }
}
</script>
<style scoped>
.introimg{
  display: flex;
    align-items: center;
}
.intro {
  text-align: center;
  width: 75px;
  height: 35px;
  line-height: 35px;
  background: #f5a93e;
  border-radius: 4px 4px 4px 4px;
  color: #FFFFFF ;
  margin-left: 30px;
  /* margin: 0 auto; */
  }
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  /* height: 200px; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor3.vue